import { useMemo } from 'react';

import {
  GENERATION_TOOL,
  GENERATION_TOOL_GROUP,
  getTeadsTools,
  getToolDescription,
  getToolsByGroup,
  getToolTitle,
  isRewriteGenerationTool,
} from 'src/data/generationTool';
import { isTeadsUI } from 'src/i18n';

import { useGenerationToolSettings } from '../useGenerationToolSettings';

import { createBadgeTypeToolMapper } from './utils';

const TOOL_GROUPS = Object.values(GENERATION_TOOL_GROUP);

const appendTeads = (tools, shouldAppend) => {
  if (shouldAppend) {
    return [...tools, ...getTeadsTools()];
  }
  return tools;
};

export const mapGenerationTool = (generationTool) => ({
  tool: generationTool,
  title: getToolTitle(generationTool),
  description: getToolDescription(generationTool),
});

export const useDocumentGroupedToolsWithoutRewritesAndBlog = (toolGroups = null) => {
  const teadsAvailable = isTeadsUI();
  const { newTools, improvedTools } = useGenerationToolSettings();

  const allTools = useMemo(() => {
    return TOOL_GROUPS.reduce((acc, toolGroup) => {
      let tools = getToolsByGroup(toolGroup);

      tools = tools.filter(
        (tool) => !isRewriteGenerationTool(tool) && !(tool === GENERATION_TOOL.blogDescription)
      );

      const shouldAppendTeads = teadsAvailable && toolGroup === GENERATION_TOOL_GROUP.ads;
      const toolsWithTeads = appendTeads(tools, shouldAppendTeads);
      const mappedTools = toolsWithTeads
        .map(mapGenerationTool)
        .map(createBadgeTypeToolMapper(newTools, improvedTools));

      return [...acc, { toolGroup, tools: mappedTools }];
    }, []);
  }, [teadsAvailable, newTools, improvedTools]);

  return useMemo(() => {
    if (Array.isArray(toolGroups) && toolGroups.length > 0) {
      return allTools.filter(({ toolGroup }) => toolGroups.includes(toolGroup));
    }

    return allTools;
  }, [allTools, toolGroups]);
};
